<template>
<b-row>
	<b-col>
		<!--
		<div class="text-center">
			<b-img :src="'images/detail/inspection/'+icon+'.svg'" height="200" class="my-5"></b-img>
		</div>
		-->
		<b-tabs content-class="pt-5 mt-3" class="macal-tabs car-general-tabs" >
			<b-tab v-for="(data, index) in this.inspection" :key="index">
				<template slot="title">
					<font-awesome-icon :icon="['fas', 'check-circle']" class="text-success mr-2" v-if="setIcon(data.data)" />
					<font-awesome-icon :icon="['fas', 'exclamation-circle']" class="text-warning mr-2" v-else />
					{{data.title}}
				</template>
				<b-card-group deck class="card-cars">
					<b-card no-body	 v-for="(element, key) in data.data" :key="key" border-variant="light" class="no-border">
						<b-table-simple borderless>
							<b-tr>
								<b-td width="1%">
									<font-awesome-icon :icon="['fas', 'check-circle']" size="lg" class="text-success mr-2" v-if="element.value" />
									<font-awesome-icon :icon="['fas', 'exclamation-circle']" size="lg" class="text-warning mr-2" v-else />
								</b-td>
								<b-td>
									<small>{{element.title}}</small>
								</b-td>
							</b-tr>
						</b-table-simple>
					</b-card>
				</b-card-group>
			</b-tab>
		</b-tabs>
	</b-col>
</b-row>
</template>

<script>
  export default {
	name: 'v-inspection-detail',
	props: {
		inspection: null
	},
	data (){
		return{
			icon: this.inspection[0].icon
		}
	},
	methods: {
		setIcon(item) {
			let response = null;
			if(item){
				response = true;
				let filtered = item.filter(value => value.value === false).length;
				if(filtered > 0){
					response = false;
				}
			}else{
				response = false;
			}
			return response;
		},
		changeIcon(icon){
			this.icon= icon;
		}
	},
	mounted() { }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
